export const parseBoolean = (bool: string | null | undefined): boolean =>
	bool && bool.toLowerCase() === 'true' ? true : false;
